module.exports = __webpack_public_path__ + "static/media/guide1.66782291.png";